export let state = {
    isMenuActive: false,
    activeTrackingAsideTab: 'Journeys',
}
